import { render } from "./Goods.vue?vue&type=template&id=0e90ae52&scoped=true"
import script from "./Goods.vue?vue&type=script&setup=true&lang=js"
export * from "./Goods.vue?vue&type=script&setup=true&lang=js"

import "./Goods.vue?vue&type=style&index=0&id=0e90ae52&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e90ae52"],['__file',"src/pages/components/parts/Goods.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e90ae52"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e90ae52', __exports__)) {
    console.log('reload')
    api.reload('0e90ae52', __exports__)
  }
  
  module.hot.accept("./Goods.vue?vue&type=template&id=0e90ae52&scoped=true", () => {
    console.log('re-render')
    api.rerender('0e90ae52', render)
  })

}


export default __exports__